import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import LayoutContainer from 'components/Common/LayoutContainer'
import OfferGoogleBreadcrumbsStructuredData from './OfferGoogleBreadcrumbsStructuredData'
import BodyText from 'LuxKit/Typography/BodyText'
import Caption from 'LuxKit/Typography/Caption'
import TextLink from 'LuxKit/TextLink'

const RelatedItemsGrid = styled(LayoutContainer)`
  margin-top: ${rem(32)};
  padding-bottom: ${rem(32)};

  ${mediaQueryUp.tablet} {
    display: none;
  }
`

const MobileRelatedItems = styled.ul`
  list-style-type: none;
  margin: ${rem(8)} 0 0 0;

  > li + li {
    margin-top: ${rem(8)};
  }
`

interface Props {
  offer: App.Offer | App.BedbankOffer
  title?: string
  regionCode: string
  items: Array<App.BreadcrumbItem>
  selfLinkItem?: React.ReactNode
}

function BottomMobileRelatedTravelItems({ offer, title, regionCode, items, selfLinkItem }: Props) {
  return <>
    <OfferGoogleBreadcrumbsStructuredData
      market={regionCode}
      offer={offer}
      relatedTravelItems={items}
    />
    <RelatedItemsGrid>
      <BodyText weight="bold" variant="large">{title || 'Related Travel'}</BodyText>
      <MobileRelatedItems>
        {selfLinkItem && <li>{selfLinkItem}</li>}
        {items.map((item, index) => <li key={index}>
          {item.url && <TextLink title={item.text} weight="regular" size="caption" to={item.url}>{item.text}</TextLink>}
          {!item.url && <Caption variant="medium">{item.text}</Caption>}
        </li>)}
      </MobileRelatedItems>
    </RelatedItemsGrid>
  </>
}

function mapStateToProps(state: App.State) {
  return {
    regionCode: state.geo.currentRegionCode,
  }
}

export default connect(mapStateToProps)(BottomMobileRelatedTravelItems)
